<template>
	<div id="gycj">
		<VAccount></VAccount>
		<div style="height: 116px;"></div>
		<VBanner></VBanner>
		<!--主体内容开始-->
	<div class="content_box1">
		<div class="content_box2">
			<!--左侧菜单-->
			<div class="menu_box">
				<p class="menu_box_title">留言板<span>Message</span></p>
				<ul class="menu_box1">
		          <li><a href="">留言板</a></li>
		       </ul>
			</div>
			<!--右侧主体-->
		<div class="content_boxL">
		       <div class="content_boxL_nav">
		         <p class="content_boxL_nav_title">留言板</p>
		       </div>
		       <!--留言板表单-->
		        <div class="lyb">
		        	<div class="lyb_form">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					  <el-form-item label="公司名称" prop="pName">
					  	<el-col :span="8">
					    <el-input v-model="ruleForm.pName"></el-input>
					    </el-col>
					  </el-form-item>
					  <el-form-item label="联系人姓名" prop="name">
					  	<el-col :span="8">
					    <el-input v-model="ruleForm.name"></el-input>
					    </el-col>
					  </el-form-item>
					  <el-form-item label="联系电话" prop="tel">
					  	<el-col :span="8">
					    <el-input v-model="ruleForm.tel"></el-input>
					    </el-col>
					  </el-form-item>
					  <el-form-item label="邮箱" prop="email">
					  	<el-col :span="8">
					    <el-input v-model="ruleForm.email"></el-input>
					    </el-col>
					  </el-form-item>
					  <el-form-item label="公司地址" prop="dz">
					  	<el-col :span="8">
					    <el-input v-model="ruleForm.dz"></el-input>
					    </el-col>
					  </el-form-item>
					  <el-form-item label="留言内容" prop="ms">
					  	<el-col :span="10">
					    <el-input type="textarea" v-model="ruleForm.ms"></el-input>
					    </el-col>
					  </el-form-item>
					  <el-form-item label="验证码">
							<slide-verify :l="40" :r="10" :w="280" :h="75" @success="onSuccess" @fail="onFail" @refresh="onRefresh" :slider-text="text" >								
							</slide-verify>
					  </el-form-item>
					  <el-form-item>
					    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
					    <el-button @click="resetForm('ruleForm')">重置</el-button>
					  </el-form-item>
					</el-form>
					</div>
		        </div>
		<div class="clear"></div>
		</div>
		</div>
	</div>
	<VFooter></VFooter>
	</div>
</template>

<script>
import web from "@/assets/js/web.js"
import VAccount from '../subcomponents/account'
import VBanner from '../subcomponents/banner'
import VFooter from '../subcomponents/footer'
import qs from 'qs'
export default{
	components:{VAccount,VBanner,VFooter},
	data(){
		return{
		text:'向右滑动',
		yzm:0,
	 	ruleForm: {
	 		pName:'',
	        name: '',
			tel:'',
			email:'',
			dz:'',
	        ms: '',
	  },
		 rules: {
		          pName: [
		            { required: false, message: '请输入公司名称', trigger: 'blur' },
		            { min: 3, max:50, message: '长度在 3 到 5 个字符', trigger: 'blur' }
		          ],
		          name: [
		            { required: true, message: '请输入联系人姓名', trigger: 'blur' },
		            { min: 2, max:20, message: '长度在 2 到 5 个字符', trigger: 'blur' }
		          ],
		          tel: [
		            { required: true, message: '请输入联系电话', trigger: 'blur' },
		            { min: 3, max:20, message: '长度在 3 到 5 个字符', trigger: 'blur' }
		          ],
		          email: [
		            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
		            { min: 3, max:50, message: '长度在 3 到 5 个字符', trigger: 'blur' }
		          ],
		          dz: [
		            { required: false, message: '请输入公司地址', trigger: 'blur' },
		            { min: 3, max:100, message: '长度在 3 到 5 个字符', trigger: 'blur' }
		          ],
		          ms: [
		            { required: true, message: '请填写留言内容', trigger: 'blur' },
		            { min: 3, max:500, message: '长度在 3 到 500 个字符', trigger: 'blur' }
		          ],
		        }
		}
	},
	created(){
		
	},
	methods:{
		onSuccess(){
			this.yzm = 1;
		},
        onFail(){
            this.yzm = 0
        },
        onRefresh(){
            this.yzm = 0;
        },
		submitForm(formName){
		var formData1 = this.ruleForm;
		console.log(formData1);
        this.$refs[formName].validate((valid) =>{
          if (valid) {
			web.api.post('/lyb',formData1).then(res=>{
				if(res.data&&this.yzm==1){
					this.$notify({
						type:'success',
						message:'提交成功',
						duration:3000
					})
					this.$refs[formName].resetFields();
					this.$options.methods.onRefresh.bind(this)();
				}else{
				this.$message({
					type: 'error',
					message: '信息填写或验证码错误', 
					showClose: true
				})
				}
			}).catch((err)=>{
				this.$message({
                type: 'error',
                message: '网络错误，请重试',
                showClose: true
			})
        })
		}else {
            console.log('error submit!!');
            return false;
          }
      });
    },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
	},
}
</script>

<style scoped>
.content_box1 {
    width: 100%;
    position: relative;
    top:-40px;
    z-index: 595;
    left: 0;
}
.content_box2 {
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
    /*box-shadow: 0 0 6px #CCC;
	border: 1px solid white;*/
}
.menu_box {
    width: 207px;
    float: left;
}
.menu_box_title {
    width: 207px;
    height: 83px;
    color: white;
    font-size: 24px;
    text-align: center;
    padding-top: 20px;
    background:#419AD6;
}
.menu_box1 {
    width: 207px;
}
.menu_box1 li {
    width: 207px;
    height: 46px;
    font-size: 16px;
    margin: 2px 0;
    text-align: center;
    line-height: 46px;
}
.menu_box1 li a {
    color: #656565;
    display: block;
    background: #cacaca;
    width: 207px;
    height: 46px;
}
.menu_box_title span {
    display: block;
    font-size: 20px;
    color: #fff;
}
/*右侧*/
.content_boxL {
    width: 978px;
    float: right;
    overflow: hidden;
}
.content_boxL_nav {
    width: 978px;
    height: 56px;
    line-height: 56px;
    margin-top: 47px;
    overflow: hidden;
    border-bottom: 1px solid #cacaca;
}
.content_boxL_nav_title {
    float: left;
    font-size: 18px;
    color: #363636;
}
.content_boxL_nav_R {
    float: right;
}
.content_boxL_nav_R a {
    color: #363636;
}
.content_boxL_text {
    width: 945px;
    margin: 0 auto 80px;
}
.content_boxL_text p {
    text-indent: 2em;
    font: 14px/24px "微软雅黑";
    color: #666666;
    margin: 30px 0;
}
.clear {
    clear: both;
}
/*留言板*/
.lyb{
	margin-top:10px;
}
.lyb_form{
	padding-left:100px;
}
</style>


// WEBPACK FOOTER //
// src/components/lyb/lyb.vue